
import { Vue, Component } from 'vue-property-decorator';

@Component({
  props: {
    padded: Boolean,
    smallPadded: Boolean,
    textAlignLeft: Boolean,
    header: String,
    isSubheader: Boolean,
    subheader: String,
    bigSubheader: String,
    h1: Boolean,
    h2min: Boolean,
    h2middle: Boolean,
    buttonText: String,
    buttonHref: String,
  },
  computed: {
    rootClass() {
      return {
        [this.$style.root]: true,
        [this.$style.padded]: this.$props.padded,
        [this.$style['small-padded']]: this.$props.smallPadded,
        [this.$style['text-left']]: this.$props.textAlignLeft,
      };
    },
    h1Class() {
      return [[this.$style.header], this.$style['h2--large']];
    },
    h2Class() {
      return {
        [this.$style.header]: true,
        [this.$style['h2--large']]: !this.$props.h2min && !this.$props.h2middle,
        [this.$style['h2--middle']]: this.$props.h2middle,
      };
    },
    subheaderClass() {
      return {
        [this.$style.subheader]: true,
        [this.$style['mobile-center']]: this.$props.isSubheader,
      };
    },
    bigSubheaderClass() {
      return [[this.$style.bigSubheader]];
    },
  },
})
export default class HeaderBlock extends Vue {}
